import React from 'react';
import ReservationCardStore from './stores/ReservationCardStore';
import ReservationCardActions from './actions/ReservationCardActions';
import ReservationCardLoadingSpinner from './ReservationCardLoadingSpinner'
import ReservationCardWorkspace from './ReservationCardWorkspace';
import ModalHeader from '../ModalButtons/ModalHeader';
import ModalButtons from '../ModalButtons/ModalButtons';
import Tabs from '../Tabs/Tabs';


export default class ReservationCard extends React.Component {
  constructor(props) {
    super(props)
    this.ReservationCard = React.createRef()
    this.state = this.getStateFromStores();
    this._onChange = this._onChange.bind(this);
    this.onCloseAndRefresh = this.onCloseAndRefresh.bind(this);
  }

  componentDidMount() {
    ReservationCardStore.addChangeListener(this._onChange);
    ReservationCardActions.init(this.props)

    window.reservationUpdated =  () => {
      ReservationCardActions.init(this.props)
    };

    $(window).on("refresh_data_table", () => {
      this.setState({ reLoadData: true })
      ReservationCardActions.init(this.props)
      ReservationCardActions.refresh(this.props);
    });
  };

  getStateFromStores() {
    return ReservationCardStore.getState();
  }

  render() {
    var buttons = [
      {
        name: I18n.t('done'),
        html_attributes: [
          'data-dismiss="modal"'
        ],
        onClick: (e) => {
          this.onCloseAndRefresh()
        }
      }];

    return(
      
      <div className="ReservationCard">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          {/* <ReservationCardLoadingSpinner show={this.state.loading} /> */}
          {/* <ReservationCardTabs {...this.state} /> */}
          <ModalHeader onClick={this.onCloseAndRefresh} />
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          {
            this.state.initialized 
            ? 
            <ReservationCardWorkspace {...this.state}
                refreshFolioTableCallback={this.refreshFolioTableCallback}
                update_cc_path={this.props.edit_reservation_cc_path}
              /> 
            : 
            null
          }
        </div>
      </div>
    )
  }

  onCloseAndRefresh() {
    parent.refresh_data();
    parent.hide_modal();
  };

  _onChange() {
    this.setState(this.getStateFromStores());
  };

  tabs() {
    if (this.state.reservation && this.state.reservation.status != "held") {
      return (
        [
          {
            tabName: I18n.t('details'),
            targetName: 'details',
            classes: this.state.active_tab === 'details' ? 'active' : null,
            changeHandler: ReservationCardActions.setActiveTab,
          },
          {
            tabName: I18n.t('folios'),
            targetName: 'folios',
            classes: this.state.active_tab === 'folios' ? 'active' : null,
            changeHandler: ReservationCardActions.setActiveTab,
          },
          {
            tabName: I18n.t('notes'),
            targetName: 'notes',
            classes: this.state.active_tab === 'notes' ? 'active' : null,
            changeHandler: ReservationCardActions.setActiveTab,
            labelCount: this.state.note_count,
          },
        ]
      )
    } else {
      return (
        [
          {
            tabName: I18n.t('details'),
            targetName: 'details',
            classes: this.state.active_tab === 'details' ? 'active' : null,
            changeHandler: ReservationCardActions.setActiveTab,
          },
          {
            tabName: I18n.t('notes'),
            targetName: 'notes',
            classes: this.state.active_tab === 'notes' ? 'active' : null,
            changeHandler: ReservationCardActions.setActiveTab,
            labelCount: this.state.note_count,
          },
        ]
      );
    };

  };

  refreshFolioTableCallback = () => {
    this.setState({ reLoadData: false })
  }

};
